var _path, _path2, _path3, _path4, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLeaderAccount = function SvgLeaderAccount(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -2.92514e-06 15.001 -2.56302e-06C6.7167 -2.2009e-06 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 30.001C23.2852 30.001 30.001 23.2852 30.001 15.001C30.001 6.71671 23.2852 0.000976563 15.001 0.000976563C6.71671 0.000976563 0.000976562 6.71671 0.000976562 15.001C0.000976562 23.2852 6.71671 30.001 15.001 30.001Z",
    fill: "url(#paint0_radial_2139_114292)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -1.01779e-06 15.001 -6.55671e-07C6.7167 -2.93554e-07 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "url(#paint1_linear_2139_114292)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -1.01779e-06 15.001 -6.55671e-07C6.7167 -2.93554e-07 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "url(#paint2_radial_2139_114292)",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2139_114292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4376 8.125C17.8154 8.125 17.2482 8.3395 16.7876 8.68738C17.3892 9.49038 17.7501 10.4838 17.7501 11.5625V12.25C17.7501 12.9052 17.6174 13.5301 17.3788 14.1001C17.7054 14.2362 18.0622 14.3125 18.4376 14.3125C19.9563 14.3125 21.1876 13.0812 21.1876 11.5625V10.875C21.1876 9.35631 19.9563 8.125 18.4376 8.125Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 15.6875C11.0393 15.6875 9.5 14.1482 9.5 12.25V11.5625C9.5 9.66431 11.0393 8.125 12.9375 8.125C14.8357 8.125 16.375 9.66431 16.375 11.5625V12.25C16.375 14.1482 14.8357 15.6875 12.9375 15.6875Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4517 16.6534C21.5689 16.2478 20.0557 15.6875 18.4374 15.6875C17.6158 15.6875 16.8217 15.8326 16.1226 16.0278C16.3811 16.0814 16.6402 16.1358 16.8994 16.2018C18.9007 16.7119 20.3163 18.4533 20.4689 20.5H22.5624C22.9419 20.5 23.2499 20.192 23.2499 19.8125V17.9019C23.2499 17.3643 22.9405 16.8776 22.4517 16.6534Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4375 21.875H7.4375C7.058 21.875 6.75 21.567 6.75 21.1875V20.8609C6.75 19.2969 7.79981 17.9205 9.31506 17.5341C10.3284 17.2756 11.5769 17.0625 12.9375 17.0625C14.2981 17.0625 15.5466 17.2756 16.5599 17.5341C18.0752 17.9205 19.125 19.2969 19.125 20.8609V21.1875C19.125 21.567 18.817 21.875 18.4375 21.875Z",
    fill: "#001947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2139_114292)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62503 22.4999C12.3591 22.4999 20.25 14.6089 20.25 4.87489C20.25 3.46315 20.0841 2.09017 19.7705 0.774414C25.7161 2.7674 30 8.38336 30 14.9999C30 23.2842 23.2843 29.9999 15 29.9999C9.44343 29.9999 4.59251 26.9785 2.00049 22.489C2.20778 22.4963 2.41598 22.4999 2.62503 22.4999Z",
    fill: "url(#paint3_linear_2139_114292)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2139_114292",
    x: 0.667155,
    y: -0.558919,
    width: 30.6662,
    height: 31.8923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2139_114292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2139_114292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2139_114292",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9456 -4.75482e-05) rotate(135) scale(26.2404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2139_114292",
    x1: 13.751,
    y1: -2.5,
    x2: 0.000974612,
    y2: 17.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2139_114292",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5002 7.125) rotate(143.291) scale(35.5496 29.3442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2139_114292",
    x1: 16.0041,
    y1: 29.9999,
    x2: 19.7477,
    y2: 8.84723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2139_114292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(6.75 6.75)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeaderAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/leader-account.1669de6d.svg";
export { ForwardRef as ReactComponent };